import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import RedirectButton from "../RedirectButton";
import ClaimRewardsBanner from "../../components/ClaimRewardsBanner";



const DesktopHome = () => {
  const navigate = useNavigate();
  const redirectURL = localStorage.getItem('redirectUrl');



  const navigateHandler = () => {
    const redirectURL = localStorage.getItem('redirectUrl');
    if (redirectURL) {
      window.location.href = redirectURL;
    } else {
      // console.log("No redirect URL found");
    }
  };

  return (
    <div className="h-[100vh] w-[100vw] bg-gradient-to-b from-[#253246] to-[#1e2738] flex justify-center items-center overflow-hidden">
      <div className="h-[85vh] w-[85vw] text-white flex flex-col">

        <nav className="w-full flex items-center justify-between px-[2vw] py-[1.5vh]">
          <img src="./econet.png" alt="" className="w-[14vw]" />
          <div className="flex items-center justify-center gap-[1.5vw] font-semibold text-[1.1vw]">
            <h1 className="cursor-pointer hover:text-[#3CB8D4]" onClick={navigateHandler}>VR games</h1>
            <h1 className="cursor-pointer hover:text-[#3CB8D4]" onClick={navigateHandler}>VR Content</h1>
            <h1 className="cursor-pointer hover:text-[#3CB8D4]" onClick={() => navigate('/profile')}>Profile</h1>
            <h1 className="cursor-pointer hover:text-[#3CB8D4]" onClick={() => navigate('/howitworks')}>How It Works</h1>
            <h1 className="cursor-pointer hover:text-[#3CB8D4]" onClick={() => navigate('/terms')}>Ts & Cs & FAQs</h1>
            <button
              className="bg-[#3CB8D4] px-[1vw] py-[0.6vh] rounded-xl text-black text-[1vw] font-semibold"
              onClick={() => navigate('/unsubscribe')}
            >
              Unsubscribe
            </button>
          </div>
        </nav>

        <div className="flex flex-1 px-[2vw] justify-around items-center">
          <div className="flex flex-col w-[40%] gap-[1vh]">
            <h1 className="text-gray-300 text-[2.2vw] mb-[1vh]">Welcome to</h1>
            <img className="w-[18vw] mb-[2vh]" src="YoGamesXR.png" alt="" />
            
            <ClaimRewardsBanner />

            <p className="text-[1.1vw] mb-[2vh] leading-relaxed">
              Experience the future of gaming and immerse yourself in worlds beyond your
              wildest dreams. Get ready to dive into digital gaming realities like never before.
            </p>
           <RedirectButton/>
          </div>
          <div className="flex items-center justify-center w-[45%]">
            <img src="authpagepeople.png" alt="" className="w-[30vw] max-h-[65vh] object-contain" />
          </div>
        </div>

      </div>
    </div>
  );
};


export default DesktopHome;